<template>
  <div class="home" id="home">
    <div @click="toggleMenu()" id="hamburger" class="hamburger hamburger--squeeze js-hamburger" :class="{ 'is-active' : menuOpen }">
      <div class="hamburger-box">
        <div class="hamburger-inner"></div>
      </div>
    </div>

    <div class="wrapper home-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center aos-holder" data-aos="fade-up">
            <h1>Fenix Bend Kula</h1>
            <p>Bend koji svira sve žanrove muzike, narodne pesme, zabavne pesme, starije i novije generacije, kao i svadbe, razna veselja, klupske svirke i ostalo...</p>
            <!--<div class="top-line"></div>-->
            <!--<div class="right-line"></div>-->
            <!--<div class="bottom-line"></div>-->
            <!--<div class="left-line"></div>-->
            <!--<a href="#" class="btn main-btn">Lorem ipsum</a>-->
            <!--<a href="#" class="btn tp-btn">Lorem ipsum</a>-->
            <a href="mailto:andorfenix@open.telekom.rs?Subject=Cao%20Fenixovci" class="btn main-btn" target="_top">Pošaljite mail</a>
            <a href="https://bendovisrbije.com/fenix-band/" class="btn tp-btn" target="_blank">Bendovi Srbije</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    data() {
      return {
        menuOpen: false,
      }
    },
    mounted() {
      let scrollpos = window.scrollY
      const header = document.querySelector("#header")
      const header_height = header.offsetHeight
      const add_class_on_scroll = () => header.classList.add("scrolled")
      const remove_class_on_scroll = () => header.classList.remove("scrolled")
      window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;
        if (scrollpos >= header_height) { add_class_on_scroll() }
        else { remove_class_on_scroll() }
      })
    },
    methods: {
      toggleNav() {
        this.menuOpen = !this.menuOpen;
      },
      closeNav() {
        this.menuOpen = false;
      },
      toggleMenu() {
        document.getElementById('header').classList.toggle('shown');
        document.getElementById('hamburger').classList.toggle('is-active');
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/HomeSection.vue